/* eslint-disable react/prop-types, no-param-reassign */
import React from 'react';
import { t } from 'es6/services/localization';
import { StyleSheet, css } from 'aphrodite';

import {
  DIFFICULTY_LEVEL_BEGINNER,
  DIFFICULTY_LEVEL_LOWER_INTERMEDIATE,
  DIFFICULTY_LEVEL_INTERMEDIATE,
  DIFFICULTY_LEVEL_UPPER_INTERMEDIATE,
  DIFFICULTY_LEVEL_ADVANCED,
} from 'es6/models/goal';

import {
  DIFFICULTY_LEVEL_BEGINNER_COLOR,
  DIFFICULTY_LEVEL_LOWER_INTERMEDIATE_COLOR,
  DIFFICULTY_LEVEL_INTERMEDIATE_COLOR,
  DIFFICULTY_LEVEL_UPPER_INTERMEDIATE_COLOR,
  DIFFICULTY_LEVEL_ADVANCED_COLOR,
} from 'es6/core/styles/colors';

export default function DifficultyLevel({ level, goal }) {
  level = level || goal.difficultyLevel;
  const mapping = LEVEL_MAPPING.get(level);
  return (
    <span className={css(styles.difficulty)}>
      <span>{t('level-label')} </span>
      <span className={css(styles[mapping.className])}>
        {mapping.label}
      </span>
    </span>
  );
}

const LEVEL_MAPPING = Object.freeze(new Map([
  [
    DIFFICULTY_LEVEL_BEGINNER,
    {
      label: t('beginner'),
      color: DIFFICULTY_LEVEL_BEGINNER_COLOR,
      className: 'beginner',
    },
  ],
  [
    DIFFICULTY_LEVEL_LOWER_INTERMEDIATE,
    {
      label: t('lower intermediate'),
      color: DIFFICULTY_LEVEL_LOWER_INTERMEDIATE_COLOR,
      className: 'lowerIntermediate',
    },
  ],
  [
    DIFFICULTY_LEVEL_INTERMEDIATE, {
      label: t('intermediate'),
      color: DIFFICULTY_LEVEL_INTERMEDIATE_COLOR,
      className: 'intermediate',
    },
  ],
  [
    DIFFICULTY_LEVEL_UPPER_INTERMEDIATE, {
      label: t('upper intermediate'),
      color: DIFFICULTY_LEVEL_UPPER_INTERMEDIATE_COLOR,
      className: 'upperIntermediate',
    },
  ],
  [
    DIFFICULTY_LEVEL_ADVANCED, {
      label: t('advanced'),
      color: DIFFICULTY_LEVEL_ADVANCED_COLOR,
      className: 'advanced',
    },
  ],
]));

const styles = (() => {
  const defs = {
    difficulty: {
      fontSize: '13px',
    },
  };

  for (const { className, color } of LEVEL_MAPPING.values()) {
    defs[className] = {
      fontWeight: 'bold',
      color,
    };
  }

  return StyleSheet.create(defs);
})();
